import React from 'react';
import DotsLoader from '@nexus/lib-react/dist/core/Loading/DotsLoader';
import styled from '../../../../theme/styled';

const LoaderWrapper = styled.div`
  padding: 16px 0;
  width: 100%;
  display: flex;
  justify-content: center;
`;

function LoadingDots() {
  return (
    <LoaderWrapper data-cy="loading-dots" data-testid="loading-dots">
      <DotsLoader />
    </LoaderWrapper>
  );
}

export default LoadingDots;
